import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useFetch } from "../../hooks/useFetch";
import { CustomToast } from "../../components";
import { useAuth } from "../../hooks/useAuth";
import { useSearchParams } from "react-router-dom";
import * as routesNames from "../../constants/routes";

const SSO = () => {
   
    const [searchParams] = useSearchParams();

const token = searchParams.get("token");

    const navigate = useNavigate();

    const { login } = useAuth();

    const { addToast } = CustomToast();

    const { fetchApi } = useFetch(addToast);

    useEffect(() => {

        autoLogin();

    }, []);

    async function autoLogin() {

    const result = await fetchApi(
        "Employee_Detail/login-sso",
        "POST",
        {
            token
        },
        null,
        ""
    );

     if (!result) {

         navigate(routesNames.LOGIN);

         return;
     }

    sessionStorage.setItem(
        "loginData",
        JSON.stringify(result)
    );

    login(result);
    console.log("logged");
    console.log(sessionStorage.getItem("loginData"));
    // navigate(routesNames.DASHBOARD);
}

    

    return (
        <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh"
        }}>
            Authenticating...
        </div>
    );
};

export default SSO;